var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagicStick = function SvgMagicStick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98832 6.78653L6.72965 5.04649M5.49996 1.5V2M3.02505 7.97487L2.67149 8.32843M8.32842 2.67157L7.97487 3.02513M3.02509 3.02509L2.67154 2.67153M2.00001 5.5H1.5M10.0612 8.2517L6.09842 4.28298C5.72349 3.90723 5.11499 3.90545 4.73788 4.27902L4.28516 4.72747C3.90625 5.10282 3.90476 5.7144 4.28184 6.09158L8.25005 10.0599C9.53324 11.3435 11.3432 9.53659 10.0612 8.2517Z",
    stroke: "#6B44A5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMagicStick;